export default "__VITE_ASSET__7f771bdf__"